export const columns = [
	{
		key: 'deviceNo',
		name: '设备通讯编号',
		fixed: 'left',
		tooltip: true,
	},
	{
		key: 'designNo',
		name: '外观编号',
		tooltip: true,
	},
	{
		key: 'waterRegionName',
		name: '所属区域',
		tooltip: true,
	},
	{
		key: 'userTypeName',
		name: '客户类型',
		tooltip: true,
	},
	{
		key: 'userNo',
		name: '用户号',
		tooltip: true,
	},
	{
		key: 'username',
		name: '客户名称',
		tooltip: true,
	},
	{
		key: 'deviceTypeName',
		name: '设备类型名称',
		tooltip: true,
	},
	{
		key: 'manufacturerName',
		name: '设备厂商',
		tooltip: true,
	},
]
